import { useState } from "react";
import { RichTextEditor } from "../RichTextEditor/RichTextEditor";

import { ClickAwayListener } from "@mui/material";

export interface IInlineRichTextEdit {
    placeholder?: string;
    value?: string;
    showToolsOnFocus?: boolean;
    updateCallback?: (val: string) => void;
}

export function InlineRichTextEdit(props: IInlineRichTextEdit) {
    const [editing, setEditing] = useState(false);
    const [editValue, setEditValue] = useState(props.value || "");
    const [placeholder] = useState(props.placeholder);

    let clickAway = () => {
        setEditing(false);
    };

    let handleClick = () => {
        setEditing(true);
    };

    return (
        <ClickAwayListener onClickAway={clickAway}>
            <div onClick={handleClick}>
                <RichTextEditor
                    value={editValue}
                    placeholder={placeholder}
                    onChange={(value) => {
                        setEditValue(value);
                        if (props.updateCallback) {
                            props.updateCallback(value);
                        }
                    }}
                    readOnly={!editing}
                    hideTools={!editing && props.showToolsOnFocus}
                    hideBorder={!editing}
                />
            </div>
        </ClickAwayListener>
    );
}
